import { IonAccordion, IonAccordionGroup, IonCol, IonItem } from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";
import { Comp } from "../../types/comp";
import "../IonColor/color.css";
import ListTheme from "../List/ListTheme";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import "../generalCSS/stylesheet.css";

interface ContainerProps {
  endpoint: string;
  pathLogo: string;
}

const loadTheme = async (idComp: Array<any>): Promise<any> => {
  let themes: any = null;
  if (!idComp || idComp[0] === "") {
    return;
  }
  await makePOSTRequest("/themes", { _id: idComp }).then((response) => {
    themes = response;
  });

  return themes;
};

const competences = async (): Promise<Comp[]> => {
  const competences: Comp[] = [];

  await makeGETRequest(
    "/skills/videotutorial/unique?type=" +
      localStorage.getItem("techno") +
      "&pole=" +
      localStorage.getItem("pole")
  ).then(async (response) => {
    for (let i: number = 0; i < response.length; i++) {
      competences.push({
        id: response[i]._id,
        name: response[i].name,
        themesID: Object.is(response[i].id_themes, [""])
          ? null
          : response[i].id_themes,
        index: response[i].index ?? i,
        themes: [],
      });
    }
    competences.sort((a, b) => a.index - b.index);
  });

  return competences;
};

const Generique: React.FC<ContainerProps> = ({ pathLogo }) => {
  const [compList, setCompList] = useState<Comp[]>([]);
  const comptemp: Promise<Comp[]> = competences();
  const title = useRef("");

  useEffect(() => {
    title.current = "Pratique";
    title.current +=
      localStorage.getItem("techno") === "pat"
        ? " - Pole " + localStorage.getItem("pole")
        : "";
    comptemp.then((response) => {
      setCompList(response);
    });
  }, []);

  return (
    <BasicPage
      pathLogo={pathLogo}
      subtitle=""
      title={title.current}
      pathReturn="welcome"
    >
      <IonAccordionGroup>
        {compList.map((comp, i) => {
          const index = i;
          const subText = comp.name.match(/ \(.*\)/)?.[0] ?? "";

          return (
            // <div key={i}>
            //   {comp.id}
            <IonAccordion key={index}>
              <div>mdr</div>
              <IonItem
                slot="header"
                onClick={async () => {
                  if (comp.themes.length === 0) {
                    loadTheme(comp.themesID).then((res) => {
                      setCompList((old) => [
                        ...old.slice(0, i),
                        { ...old[i], themes: res },
                        ...old.slice(i + 1, old.length),
                      ]);
                    });
                  }
                }}
              >
                <span
                  className="firstLetterUpper"
                  style={{
                    textTransform: "lowercase",
                    fontWeight: "bold",
                    color: " var(--ion-color-secondary)",
                  }}
                >
                  <span
                    style={{
                      letterSpacing: 2,
                    }}
                  >
                    {comp.name.replace(subText, "")}
                  </span>{" "}
                  {subText}
                </span>
              </IonItem>
              <div slot="content">
                <ListTheme key={index} theme={comp.themes} generique={true} />
              </div>
            </IonAccordion>
          );
        })}
      </IonAccordionGroup>

      <IonCol
        hidden={!(localStorage.getItem("techno") === "pat")}
        className="ion-justify-content-end flex"
        onClick={() => {
          localStorage.setItem(
            "pole",
            localStorage.getItem("pole") === "1" ? "2" : "1"
          );
          window.location.reload();
        }}
      >
        <span className="btn fit-content padding ion-align-items-center">
          Pratique pôle {localStorage.getItem("pole") === "1" ? 2 : 1}
        </span>
      </IonCol>
    </BasicPage>
  );
};

export default Generique;
